// Gallery Carousels
const gallerySliders = document.querySelectorAll('.js-slider--gallery'),
    gallerySliderNavNext = document.querySelectorAll('.js-next-slide--gallery'),
    gallerySliderNavPrev = document.querySelectorAll('.js-prev-slide--gallery'),
    gallerySliderPagination = document.querySelectorAll('.js-pagination--gallery');

gallerySliders.forEach((el, i) => {
    const slider = new Swiper(el, {
        containerModifierClass: 'slider',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slide',
        slideActiveClass: 'slide--active',
        slideVisibleClass: 'slide--visible',
        slidesPerView: 'auto',
        effect: 'fade',
        loop: true,
        loopedSlides: 2,
        spaceBetween: 0,
        centeredSlides: true,
        watchSlidesVisibility: true,
        watchOverflow: true,
        uniqueNavElements: true,
        initialSlide: 0,
        autoplay: {
            delay: 4500
        },
        navigation: {
            nextEl: gallerySliderNavNext[i],
            prevEl: gallerySliderNavPrev[i],
            disabledClass: 'slider__button--disabled'
        },
        pagination: {
            el: gallerySliderPagination[i],
            type: 'bullets',
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });
});

// Cover Carousels
const coverSliders = document.querySelectorAll('.js-slider--cover'),
    coverSliderNavNext = document.querySelectorAll('.js-next-slide--cover'),
    coverSliderNavPrev = document.querySelectorAll('.js-prev-slide--cover');

coverSliders.forEach((el, i) => {
    const slider = new Swiper(el, {
        containerModifierClass: 'slider',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slide',
        slideActiveClass: 'slide--active',
        slideVisibleClass: 'slide--visible',
        slidesPerView: 'auto',
        loop: true,
        loopedSlides: 2,
        spaceBetween: 12,
        centeredSlides: true,
        watchSlidesVisibility: true,
        watchOverflow: true,
        uniqueNavElements: true,
        initialSlide: 1,
        navigation: {
            nextEl: coverSliderNavNext[i],
            prevEl: coverSliderNavPrev[i],
            disabledClass: 'slider__button--disabled'
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        breakpoints: {
            768: {
                spaceBetween: 24
            },
        },
    });
});